export class GalleryPaintableData {
    public readonly colours: number[];
    public readonly sequence: number[];

    constructor(pSequence: number[], pColours: number[]) {
        this.sequence = pSequence;
        this.colours = pColours;
    }
}
